import axios from 'axios';
import userUtil from '@/utils/user.util';

const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8989/';
const apiPrefix = process.env.VUE_APP_API_PREFIX || '';
const cardsUrl = process.env.VUE_APP_CARDS_API || '';
const folderCardsUrl = process.env.VUE_APP_FOLDER_CARDS_API || '';

export default {
  api(url) {
    // const url = cards ? cardsUrl : folder ? folderCardsUrl : baseUrl + apiPrefix;
    return axios.create({
      baseURL: url ? url : (baseUrl + apiPrefix),
      headers: {
        'x-requested-with': 'XMLHttpRequest',
        'content-type': 'application/x-www-form-urlencoded',
      },
    })
  },
  setupDeviceIdHeaders(headers = {}) {
    const deviceId = userUtil.getDeviceId();
    const newHeaders = headers;

    if (deviceId != null) {
      newHeaders['X-Kidjo-DeviceId'] = deviceId;
      
    }

    return newHeaders;
  }
};
